<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items">
          <span class="logo-lg"><img class="img" src="../../../assets/img/logo.png"></span>
          <!-- <h3>Welcome to Screenit</h3> -->
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
          <div class="container" style="width: 85% !important;">
            <div class="col-md-12">
              <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Join Interview</h4>
                </div>
                <div class="box-body">
                  <b-form class="form-signup mb-1 mt-10" v-on:submit.prevent="handleJoin" novalidate>
                      <div class="form-label-group form-forgot-password">
                        <b-form-input @keyup="clearmsg()" v-model.lazy.trim="$v.form.name.$model" :state="chkState('name')" type="text" autocomplete="new-password" class="form-control" placeholder="Name * " />
                      <!-- <span class="pwd_info">* Do not type existing password, type new password</span> -->
                        <div v-if="$v.form.name.$error">
                          <p v-if="!$v.form.name.required" class="login-alert-msg error-content">* Please enter the name</p>
                        </div>
                      </div>
                      <div class="form-label-group form-forgot-password">
                        <b-form-input @keyup="clearmsg()" v-model.lazy.trim="$v.form.channel.$model" :state="chkState('channel')" type="text" autocomplete="new-password" class="form-control" placeholder="Meeting ID * " />
                        <div v-if="$v.form.channel.$error">
                          <p v-if="!$v.form.channel.required" class="login-alert-msg error-content">* Please enter the meeting ID</p>
                        </div>
                        <div v-if="meetingid_error">
                          <p class="login-alert-msg error-content">* Meeting ID mismatch</p>
                        </div>
                      </div>
                      <!-- <div class="form-label-group">
                        <b-form-input @change="emailvalidate()" v-model.lazy.trim="$v.form.email.$model" :state="chkState('email')" v-bind:class="{ 'is-invalid': !chkState('email') }" autocomplete="new-password" type="password" class="form-control custom-input" placeholder="Password *" />
                        <span v-if="emailerror" class="pwd_info">* Please enter the registered email ID</span>

                      </div> -->
                      <div class="form-label-group form-forgot-password">
                        <b-form-input
                          :type="passwordFieldType" @keyup="clearmsg()"
                          class="form-control cleardefault"
                          placeholder="Password"
                          v-model.lazy.trim="$v.form.password.$model"
                          :state="chkState('password')"
                        />
                        <div v-if="!$v.form.password.$error">
                          <!-- <p v-if="errormsg == 'Invalid Password'" class="login-alert-msg error-content">* Incorrect password</p> -->
                        </div>
                        <span
                          class="fa fa-fw fa-eye field-icon toggle-password"
                          v-if="passwordFieldType == 'text'"
                          @click="switchVisibility"
                        ></span>
                        <span
                          class="fa fa-eye-slash field-icon toggle-password"
                          v-if="passwordFieldType == 'password'"
                          @click="switchVisibility"
                        ></span>
                        <div v-if="$v.form.password.$error">
                          <p v-if="!$v.form.password.required" class="login-alert-msg error-content">* Please enter the password</p>
                        </div>
                        <div v-if="emailerror">
                          <p class="login-alert-msg error-content">* Incorrect Password</p>
                        </div>
                      </div>
                      <button style="width: 40%;text-align:center" class="btn btn-md btn-success mt-4" type="submit">Join now</button>
                      <div style="text-align: center;" v-if="alreadyconnecterror">
                        <p style="padding: 10px;text-align: center;" class="login-alert-msg error-content">* User already logged on the same credentials in another device</p>
                      </div>
                    </b-form>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import axios from 'axios'
import { BaseURLV3 } from '../../../shared/classes'
import router from '../../../router/index'
import { logo } from '../../../shared/svg'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import momentsone from 'moment-timezone'

export default {
  data () {
    return {
      form: {
        password: '',
        name: '',
        channel: ''
      },
      joinBtn: false,
      BaseURLV3: BaseURLV3,
      meetingid_error: false,
      meetingid: '',
      baseMode: 'avc',
      transcode: 'interop',
      attendeeMode: 'video',
      videoProfile: '480p_4',
      config: {
        headers: {
          'content-type': 'application/json'
          // Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      type: '',
      logos: logo,
      start_datetime: '',
      current_date: '',
      postdatas: [],
      emailerror: false,
      emailvalidation: 1,
      passwordFieldType: 'password',
      status: '',
      alreadyconnecterror: false,
      data: [],
      timezone: momentsone.tz.guess(),
      orgName: ''
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required
      },
      name: {
        required
      },
      channel: {
        required
      }
    }
  },
  created () {
    var currentDate = new Date()
    this.current_date = moment.utc(String(currentDate)).format('YYYYMMDDHHmm')
    console.log(this.current_date)
    this.getscheduleDetails(this.$route.params.id)
  },
  methods: {
    getDate (date) {
      return momentsone(date).tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return momentsone(date).tz(this.timezone).format('hh:mm a')
    },
    switchVisibility () {
      this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    emailvalidate () {
      this.postdatas = []
      const mainurl = '/dashboard/validate_useremail'
      this.postdatas = {
        emailid: this.form.email,
        type: this.$route.params.type,
        meeting_id: this.meetingid
      }
      axios.post(`${this.BaseURLV3}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        console.log(response.data.message)
        if (response.data.message === 'Invaild Email ID' && this.$route.params.type !== 4) {
          this.emailerror = true
          this.emailvalidation = 1
        } else {
          this.emailerror = false
          this.emailvalidation = 0
        }
      }).catch(e => {
        console.log(e)
      })
    },
    startPending () {
      router.push({ name: 'MeetingStartV3', params: { id: this.$route.params.id, type: this.$route.params.type, orgName: this.orgName } })
    },
    meetingEnd () {
      router.push({ name: 'MeetingEndV3', params: { id: this.$route.params.id, type: this.$route.params.type, orgName: this.orgName } })
    },
    acceptPending () {
      router.push({ name: 'AcceptPendingV3', params: { id: this.$route.params.id, type: this.$route.params.type, orgName: this.orgName } })
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    getscheduleDetails (id) {
      const mainurl = BaseURLV3 + '/interviewer/' + id + '/meeting'
      axios.get(`${mainurl}`, this.config).then(response => {
        this.data = response.data.schedule
        console.log('this.data ', this.data)
        this.meetingid = this.data.meeting_id.toString()
        console.log('this.meetingid ', this.meetingid)
        this.status = this.data.status
        if (this.data.post_id !== null) {
          this.getPostDetails(this.data.post_id)
        } else {
          this.orgName = 'ScreenIt'
          localStorage.setItem('organization', 'ScreenIt')
          localStorage.setItem('job_title', this.data.candidate.designation)
        }
        if (this.data.status !== 'Scheduled' && this.data.status !== 'Rescheduled') {
          this.meetingEnd()
          return false
        }
        // this.orgName = this.data.interviewer_org_name
        // var date = this.data.startdatetime_utc
        // var end = this.data.enddatetime_utc
        var currentDate = new Date()
        this.current_date = moment(String(currentDate)).format('YYYYMMDDHHmm')
        console.log('currentDate ', this.current_date)
        var scheduledate = momentsone(this.data.utc_starttime).utc().tz(this.timezone).subtract(5, 'minutes').format('YYYYMMDDHHmm') // moment.utc(this.data.available_datetime).subtract(5, 'minutes').toDate()
        console.log('scheduledate ', scheduledate)
        var endtime = momentsone(this.data.utc_starttime).utc().tz(this.timezone).add(1, 'h').format('YYYYMMDDHHmm') // moment.utc(this.data.available_datetime).add(1, 'h').toDate()
        console.log('endtime ', endtime)
        if (this.data.status === 'Accepted' && (this.data.candidate_accept !== 'yes' || this.data.interviewer_accept !== 'yes')) {
          this.acceptPending()
        } else if (this.current_date < scheduledate && (this.data.status === 'Scheduled' || this.data.status === 'Rescheduled')) {
          this.startPending()
        } else if (this.current_date > endtime) {
          this.meetingEnd()
        } else if (this.current_date < scheduledate && this.data.status !== 'Scheduled' && this.data.status !== 'Rescheduled') {
          this.meetingEnd()
        }
        // if (this.data.job_interview_type === 'Video') {
        //   this.attendeeMode = 'video'
        // } else {
        //   this.attendeeMode = 'audio-only'
        // }
        this.attendeeMode = 'video'
      }).catch(e => {
        console.log(e)
      })
    },
    getPostDetails (id) {
      axios.get(BaseURLV3 + '/org/post/' + id, this.config).then(response => {
        if (response.data.success) {
          localStorage.setItem('job_title', response.data.post.job_title)
          if (response.data.post.org_id != null) {
            this.getOrgDetails(response.data.post.org_id)
          }
        }
        this.isLoading = false
        console.log('done')
      }).catch(e => {
      })
    },
    getOrgDetails (id) {
      axios.get(BaseURLV3 + '/org/' + id + '/details', this.config).then(response => {
        if (response.data.success) {
          localStorage.setItem('organization', response.data.org.org_name)
          this.orgName = response.data.org.org_name
        }
        this.isLoading = false
        console.log('done')
      }).catch(e => {
      })
    },
    handleChannel (val, state) {
      this.channel = val
      this.joinBtn = state
    },
    handleBaseMode (val) {
      this.baseMode = val
    },
    handleTranscode (val) {
      this.transcode = val
    },
    handleVideoProfile (val) {
      this.videoProfile = val
    },
    handleAttendeeMode (e) {
      this.attendeeMode = e.currentTarget.value
    },
    clearmsg () {
      this.meetingid_error = false
      this.emailerror = false
      this.alreadyconnecterror = false
    },
    handleJoin () {
      if (this.validate()) {
        if (this.meetingid !== this.form.channel) {
          this.meetingid_error = true
          return false
        } else {
          this.meetingid_error = false
        }
        this.postdatas = []
        const mainurl = BaseURLV3 + '/interviewer/' + this.$route.params.id + '/join_meeting'
        const type = this.$route.params.type
        this.postdatas = {
          password: this.form.password,
          type: type === '2' ? 'interviewer' : type === '3' ? 'candidate' : 'org',
          meeting_id: Number(this.meetingid)
        }
        axios.post(`${mainurl}`, this.postdatas, this.config).then(response => {
          console.log(response.data.message)
          this.alreadyconnecterror = false
          if (response.data.success === false) {
            this.emailerror = true
            return false
          } else {
            localStorage.setItem('type', JSON.stringify(this.$route.params.type))
            Cookies.set('channel', this.form.channel)
            Cookies.set('type', this.$route.params.type)
            Cookies.set('baseMode', this.baseMode)
            Cookies.set('transcode', this.transcode)
            Cookies.set('attendeeMode', this.attendeeMode)
            Cookies.set('videoProfile', this.videoProfile)
            Cookies.set('sid', this.$route.params.id)
            Cookies.set('name', this.form.name)
            localStorage.setItem('stType', this.$route.params.type)
            this.$router.push('/agoraMod_v3/meeting')
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        return false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('keypress', e => {
        e.keyCode === 13 && this.handleJoin()
      })
    })
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 10px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.box-header {
  padding: 10px;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #373644 !important;
}
.form-body {
  background-color: #373644 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
body {
  background-color: #373644 !important;
}
</style>
